(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/create-game-form.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/create-game-form.js');

'use strict';

const _excluded = ["teamPathName"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  useState,
  useEffect,
  useRef,
  useCallback
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useParams,
  useHistory
} = ReactRouterDOM;
const {
  Button,
  ReactIcon
} = svs.ui;
const {
  Inputv2: Input,
  ControlGroup
} = svs.ui.reactForm;
const {
  ContentRevealReact: ContentReveal
} = svs.components;
const {
  Skeleton
} = svs.components.lbUi;
const {
  MAX_FRACTIONS_PER_GAME
} = svs.components.marketplaceData.createGame.constants;
const {
  AdvancedOptions
} = svs.components.marketplace.createGame;
const {
  helpers
} = svs.components.marketplace.createGame;
const {
  actions
} = svs.components.marketplaceData.games;
const {
  betProposal: betProposalSelectors,
  games,
  form
} = svs.components.marketplaceData.selectors;
const {
  selectCreateGame
} = svs.components.marketplaceData.selectors.createGame;
const {
  getGame
} = svs.components.marketplaceData.selectors.games;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const {
  actions: createGameActions,
  helpers: createGameHelpers
} = svs.components.marketplaceData.createGame;
const {
  hooks
} = svs.components.marketplace.createGame;
const {
  getRowId
} = svs.components.marketplace.helpers;
const {
  changeFractionPrice
} = svs.components.marketplaceData.createGame.actions;
const {
  getDraw
} = svs.components.marketplaceData.selectors.draws;
const {
  changeBuyStopDiff
} = svs.components.marketplaceData.createGame.actions;
const {
  BuyStopSelector
} = svs.components.marketplace.buyStopSelector;
const MIN_FRACTION_PRICE = 0;
const MAX_FRACTION_PRICE = 10001;
const MAX_RENDER_TIMEOUT_MS = 10 * 60 * 1000;
const milliSecondsToMinutes = ms => Math.round(ms / 1000 / 60);
const CreateGameForm = _ref => {
  let {
    isEditMode,
    isLoading
  } = _ref;
  const dispatch = useDispatch();
  const nextRegCloseTime = useRef();
  const maxFracMemberRef = useRef();
  const maxFracGameRef = useRef();
  const history = useHistory();
  const {
    redirectToTeam
  } = hooks.useRedirectTo();
  const _useParams = useParams(),
    {
      teamPathName
    } = _useParams,
    params = _objectWithoutProperties(_useParams, _excluded);
  const activatedDrawId = parseInt(params.activatedDrawId, 10);
  const containerId = parseInt(params.containerId, 10);
  const groupId = parseInt(params.groupId, 10);
  const drawNotFoundDialogShown = useRef(false);
  const {
    error: drawErrorMessage,
    DrawFetchState,
    draws,
    drawState,
    productDraws
  } = hooks.useDraws({
    activatedDrawId,
    containerId,
    groupId,
    forceFetch: true
  });
  const {
    activatedDrawId: selectedActivatedDrawId,
    selectedProduct,
    selectedDraw,
    fractionPrice,
    maxFractionsPerMember,
    maxFractionsPerGame,
    buyStopDiff: selectedBuyStopDiff,
    isSelectedDrawClosed
  } = useSelector(selectCreateGame);
  const selectedGame = useSelector(state => getGame(state, {
    activatedDrawId: selectedActivatedDrawId,
    groupId
  }) || {});
  const isPriceValid = fractionPrice > MIN_FRACTION_PRICE && fractionPrice < MAX_FRACTION_PRICE;
  const isMaxFractionsPerGameValid = maxFractionsPerGame > 1 && maxFractionsPerGame <= MAX_FRACTIONS_PER_GAME;
  const isMaxFractionsPerMemberValid = maxFractionsPerMember > 0 && maxFractionsPerMember <= Math.floor(maxFractionsPerGame / 2);
  const priceIsSet = fractionPrice !== undefined;
  const betProposalKey = activatedDrawId || getRowId(selectedProduct, selectedDraw, groupId);
  const isRemoving = useSelector(state => games.getIsRemoving(state, {
    activatedDrawId,
    groupId
  }));
  const hasFormChanged = useSelector(state => form.selectIsFormChanged(state, {
    activatedDrawId,
    groupId
  }));
  const betProposal = useSelector(state => betProposalSelectors.selectCreateBetProposal(state, {
    activatedDrawId: betProposalKey
  })) || {};
  const buyStopOptions = useSelector(state => state.Config.buyStops);
  const configBuystop = useSelector(state => state.Config.selectedBuyStop);
  const buyStopDiff = selectedBuyStopDiff || configBuystop;
  const queryDrawNumber = parseInt(new URLSearchParams(history.location.search).get('drawNumber'), 10);
  const queryProductName = new URLSearchParams(history.location.search).get('productName');
  const selectedDrawnumber = queryDrawNumber || selectedDraw;
  const selectedProductName = queryProductName || selectedProduct;
  const {
    regCloseTime
  } = useSelector(state => getDraw(state, {
    drawNumber: selectedDrawnumber,
    productName: selectedProductName
  }));
  const minutesUntilDrawRegClose = milliSecondsToMinutes(regCloseTime - Date.now());
  const [advancedOptionVisiblity, toggleAdvancedOptions] = useState(() => betProposal && helpers.betProposalHasTrue(betProposal) || false);
  const disableButtons = isLoading || isRemoving;
  const canSubmit = selectedDraw && !isSelectedDrawClosed && isPriceValid && isMaxFractionsPerMemberValid && isMaxFractionsPerGameValid && !disableButtons && (hasFormChanged && isEditMode || !isEditMode);
  const {
    handleSubmit
  } = hooks.useGameSubmit({
    isEditMode,
    canSubmit
  });
  const dialogOptions = {
    title: 'Vill du verkligen radera spelet?',
    text: 'Alla insatser kommer att betalas tillbaka till lagets medlemmar.',
    icon: 'dustbin',
    buttons: [{
      text: 'Avbryt',
      classes: {
        inverted: true
      }
    }, {
      text: 'Radera',
      callback: async () => {
        dispatch(actions.removeGameAction(groupId, containerId, err => {
          if (!err) {
            redirectToTeam({
              strategy: 'replace',
              groupId,
              teamPathName
            });
          }
        }));
      }
    }]
  };
  const formatFractionPrice = value => {
    const _value = value.replace(/[^0-9]/g, '');
    return _value ? parseInt(_value, 10) : undefined;
  };
  const onMaxFractionsPerMemberChange = _ref2 => {
    let {
      target
    } = _ref2;
    const amount = parseInt((target === null || target === void 0 ? void 0 : target.value) || 0, 10);
    dispatch(svs.components.marketplaceData.createGame.actions.changeMaxFractionsPerMember(amount));
    const srOnly = maxFracMemberRef.current;
    srOnly.textContent = target.value;
  };
  const onMaxFractionsPerGameChange = _ref3 => {
    let {
      target
    } = _ref3;
    const amount = parseInt((target === null || target === void 0 ? void 0 : target.value) || 0, 10);
    dispatch(svs.components.marketplaceData.createGame.actions.changeMaxFractionsPerGame(amount));
    const srOnly = maxFracGameRef.current;
    srOnly.textContent = target.value;
  };
  const getButtonLabel = () => {
    if (isLoading) {
      return 'Sparar...';
    }
    if (isEditMode) {
      return 'Spara ändringar';
    }
    return 'Öppna spel för köp';
  };
  const handleOnRemoveButtonClick = () => {
    dispatch(showDialog(dialogOptions));
  };
  const onGoBack = () => {
    var _history$location;
    if ((_history$location = history.location) !== null && _history$location !== void 0 && (_history$location = _history$location.state) !== null && _history$location !== void 0 && _history$location.internalLink) {
      history.goBack();
    } else {
      redirectToTeam({
        groupId,
        teamPathName,
        strategy: 'replace'
      });
    }
  };
  const drawExists = useCallback(() => {
    let found;
    if (queryDrawNumber) {
      var _draws$selectedProduc;
      found = draws === null || draws === void 0 || (_draws$selectedProduc = draws[selectedProduct]) === null || _draws$selectedProduc === void 0 ? void 0 : _draws$selectedProduc.find(draw => draw.drawNumber === queryDrawNumber);
    } else if (selectedDraw) {
      var _draws$selectedProduc2;
      found = draws === null || draws === void 0 || (_draws$selectedProduc2 = draws[selectedProduct]) === null || _draws$selectedProduc2 === void 0 ? void 0 : _draws$selectedProduc2.find(draw => draw.drawNumber === selectedDraw);
    }
    return found;
  }, [draws, queryDrawNumber, selectedDraw, selectedProduct]);
  useEffect(() => {
    const newNextRegCloseTime = createGameHelpers.getNextDrawCloseTime(productDraws);
    if (!newNextRegCloseTime) {
      return undefined;
    }
    const now = new Date();
    const timeUntilClose = newNextRegCloseTime.getTime() - now.getTime();
    let renderTimeout;
    if (timeUntilClose < MAX_RENDER_TIMEOUT_MS) {
      if (nextRegCloseTime.current && nextRegCloseTime.current.getTime() === newNextRegCloseTime.getTime()) {
        return;
      }
      renderTimeout = setTimeout(() => {
        nextRegCloseTime.current = undefined;
        const drawItems = createGameHelpers.getDrawItems(draws[selectedProduct]);
        const selectedDrawItem = drawItems.find(_ref4 => {
          let {
            item
          } = _ref4;
          return selectedDraw === item.drawNumber;
        });
        const newSelectedDrawClosed = selectedDrawItem && selectedDrawItem.isDisabled;
        if (!isSelectedDrawClosed && newSelectedDrawClosed) {
          dispatch(actions.selectedDrawClosed(selectedDraw));
        }
      }, timeUntilClose);
      nextRegCloseTime.current = newNextRegCloseTime;
    }
    return () => {
      clearTimeout(renderTimeout);
    };
  }, [dispatch, draws, isSelectedDrawClosed, productDraws, selectedDraw, selectedProduct]);
  useEffect(() => () => dispatch(createGameActions.clearFormAction), [dispatch]);
  const onCloseDialog = useCallback(() => {
    redirectToTeam({
      strategy: 'replace',
      groupId,
      teamPathName
    });
  }, [groupId, redirectToTeam, teamPathName]);
  useEffect(() => {
    var _draws$selectedProduc3;
    const drawFound = (_draws$selectedProduc3 = draws[selectedProductName]) === null || _draws$selectedProduc3 === void 0 ? void 0 : _draws$selectedProduc3.find(draw => draw.drawNumber === selectedDrawnumber);
    const properDrawNumber = Number.isInteger(selectedDrawnumber) && selectedDrawnumber > 0;
    const drawsLoadedAndReady = drawState === DrawFetchState.OK && productDraws.length > 0 && Object.keys(draws).length > 0;
    if (drawState === DrawFetchState.OK && drawsLoadedAndReady && properDrawNumber && !drawFound && !drawNotFoundDialogShown.current) {
      drawNotFoundDialogShown.current = true;
      dispatch(showDialog({
        title: 'Omgången kunde inte hittas eller har hunnit stängas.',
        icon: 'information',
        buttons: [{
          text: 'Okej',
          callback: () => onCloseDialog()
        }]
      }));
    }
  }, [dispatch, selectedDrawnumber, drawState, DrawFetchState]);
  const renderToggleButton = () => !advancedOptionVisiblity && React.createElement("div", {
    className: "toggle-advanced-options"
  }, React.createElement(Button, {
    block: true,
    className: "qa-toggle-advanced-options margin-bottom-1",
    onClick: () => toggleAdvancedOptions(prev => !prev),
    transparent: true,
    type: "button"
  }, "Fyll i radskiss och meddelande", React.createElement(ReactIcon, {
    class: "margin-left marketplace-rotate",
    icon: "menu-down",
    size: "100"
  })));
  const renderErrorView = () => React.createElement("div", {
    className: "qa-no-open-draws",
    "data-testid": "no-open-draws"
  }, drawErrorMessage ? React.createElement("p", {
    className: "f-medium"
  }, drawErrorMessage) : React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-medium"
  }, isSelectedDrawClosed ? 'Den valda omgången är stängd. Det finns inga öppna omgångar just nu.' : 'Det finns inte några öppna spelomgångar för tillfället.'), React.createElement("p", null, "F\xF6rs\xF6k igen lite senare!")), React.createElement(helpers.RedirectButton, {
    className: "qa-cancel-button",
    label: "St\xE4ng"
  }));
  const renderLoadView = () => React.createElement("div", {
    className: "marketplace-full-height marketplace-center-container qa-loading-form-data"
  }, React.createElement("div", {
    className: "margin-half",
    style: {
      display: 'inline-flex',
      flexDirection: 'row'
    }
  }, React.createElement(Skeleton, {
    height: 4,
    numLines: 1,
    style: {
      width: '96px'
    }
  }), React.createElement("div", {
    className: "margin-left"
  }, React.createElement(Skeleton, {
    className: "margin-half",
    height: 1,
    numLines: 1,
    style: {
      width: '200px',
      maxHeight: '12px'
    }
  }), React.createElement(Skeleton, {
    className: "margin-half",
    height: 1,
    numLines: 1,
    style: {
      width: '150px',
      maxHeight: '12px'
    }
  }), React.createElement(Skeleton, {
    className: "margin-half",
    height: 1,
    numLines: 1,
    style: {
      width: '150px',
      maxHeight: '12px'
    }
  }))));
  const shouldShowMissingDrawError = () => {
    if (drawState !== DrawFetchState.OK || drawExists()) {
      return false;
    }
    return !productDraws.length;
  };
  if (shouldShowMissingDrawError()) {
    return renderErrorView();
  }
  if (drawState === DrawFetchState.LOADING) {
    return renderLoadView();
  }
  return React.createElement("form", {
    className: "create-game-form",
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    className: "fraction-price",
    errorMessage: "Insatsen m\xE5ste vara mellan 1 och 10 000 kr.",
    hasError: !isPriceValid && priceIsSet,
    idForInput: "create-game-input-price",
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    className: "qa-fraction-price",
    "data-testid": "fraction-price",
    disabled: isEditMode,
    id: "create-game-input-price",
    label: "Pris per andel",
    onChange: _ref5 => {
      let {
        target
      } = _ref5;
      return dispatch(changeFractionPrice(formatFractionPrice(target.value)));
    },
    suffix: "kr",
    type: "number",
    value: fractionPrice > 0 ? Number(fractionPrice) : null 
  })), React.createElement(ControlGroup, {
    className: "max-fractions-per-member",
    errorMessage: "En lagmedlem kan k\xF6pa minst 1 andel och h\xF6gst h\xE4lften av andelarna per spelomg\xE5ng.",
    hasError: !isMaxFractionsPerMemberValid,
    idForInput: "create-game-input-price",
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    className: "qa-max-fractions-per-member",
    "data-testid": "max-fractions-per-member",
    id: "qa-max-fractions-per-member",
    label: "Max antal andelar per lagmedlem",
    max: Math.floor(maxFractionsPerGame / 2),
    min: selectedGame.maxFractionsPerMember || 1,
    onChange: onMaxFractionsPerMemberChange,
    type: "number",
    value: maxFractionsPerMember > 0 ? Number(maxFractionsPerMember) : null 
  })), React.createElement("div", {
    "aria-live": "polite",
    className: "sr-only",
    id: "qa-max-fractions-per-member",
    ref: maxFracMemberRef
  }), React.createElement(ControlGroup, {
    className: "max-fractions-per-game",
    errorMessage: "En spelomg\xE5ng kan ha minst 2 andelar och h\xF6gst ".concat(MAX_FRACTIONS_PER_GAME, " andelar"),
    hasError: !isMaxFractionsPerGameValid,
    idForInput: "advanced-options-max-shares",
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    className: "qa-max-fractions-per-game",
    "data-testid": "max-fractions-per-game",
    disabled: isEditMode,
    id: "qa-max-fractions-per-game",
    label: "Max antal andelar per spelomg\xE5ng",
    max: MAX_FRACTIONS_PER_GAME,
    min: 1,
    onChange: onMaxFractionsPerGameChange,
    type: "number",
    value: maxFractionsPerGame > 0 ? Number(maxFractionsPerGame) : null 
  })), React.createElement("div", {
    "aria-live": "polite",
    className: "sr-only",
    id: "qa-max-fractions-per-game",
    ref: maxFracGameRef
  }), React.createElement("div", {
    className: "buystop-selector-container"
  }, React.createElement(BuyStopSelector, {
    className: "qa-buystop-selector f-medium",
    drawCloseTime: regCloseTime,
    label: "V\xE4lj tid f\xF6r k\xF6pstopp",
    maxValue: minutesUntilDrawRegClose,
    onChange: newBuyStop => {
      dispatch(changeBuyStopDiff(newBuyStop));
    },
    options: buyStopOptions,
    value: buyStopDiff
  })), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("h3", {
    className: "f-400 f-medium margin-bottom"
  }, "N\xE4r kan man l\xE4mna in spelet?"), React.createElement("p", {
    className: "f-400"
  }, "N\xE4r minst 2 lagmedlemmar k\xF6pt andelar kan du l\xE4mna in spelet.")), React.createElement("section", {
    className: "create-game-form-content-holder"
  }, renderToggleButton(), React.createElement(ContentReveal, {
    className: "create-game-form-content-reveal",
    show: advancedOptionVisiblity
  }, React.createElement("div", {
    className: "create-game-form-info"
  }, React.createElement("h3", {
    className: "f-medium margin-bottom"
  }, "Fyll i radskiss och meddelande"), React.createElement("p", null, "En radskiss visar dina lagmedlemmar p\xE5 ett ungef\xE4r hur du t\xE4nkt spela, eller vilken spelid\xE9 du har. Allt g\xE5r att justera innan spelet slutligen l\xE4mnas in. Du kan \xE4ven l\xE4mna ett meddelande som samtliga lagmedlemmar kan ta del av.")), React.createElement(AdvancedOptions, {
    activatedDrawId: parseInt(activatedDrawId, 10),
    groupId: Number(groupId),
    isEditMode: isEditMode
  })), isEditMode && React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    className: "qa-remove-button btn-icon-left delete-game-btn",
    "data-testid": "remove-button",
    disabled: disableButtons,
    onClick: handleOnRemoveButtonClick,
    size: 300,
    transparent: true,
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "dustbin"
  }), isRemoving ? 'Raderar...' : 'Radera spelet'), React.createElement("p", {
    className: "f-center fc-red margin-top-1"
  }, "Alla insatser betalas tillbaka om spelet raderas."))), React.createElement("div", {
    className: "create-game-form-buttons margin-top"
  }, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1 qa-submit-button",
    "data-testid": "submit-button",
    disabled: !canSubmit,
    focus: true,
    size: 300,
    type: "submit"
  }, getButtonLabel()), React.createElement(Button, {
    block: true,
    className: "cancel-button margin-bottom-1 qa-cancel-button",
    clean: "true",
    onClick: () => onGoBack(),
    size: 300
  }, "Avbryt")));
};
setGlobal('svs.components.marketplace.createGame.CreateGameForm', CreateGameForm);

 })(window);